import { Order } from '../types';

const ACTIVE_DRIVER_STATUSES = new Set<Order['status']>(['assigned', 'dispatched']);
const DEFAULT_STALE_HOURS = 18;

export const isActiveDriverOrder = (order: Order): boolean => ACTIVE_DRIVER_STATUSES.has(order.status);

export const getDriverOrderTimestamp = (order: Order): number =>
  order.statusUpdatedAt || order.pickupConfirmedAt || order.departedHubAt || order.createdAt || 0;

export const isStaleDriverOrder = (
  order: Order,
  nowMs: number = Date.now(),
  staleHours: number = DEFAULT_STALE_HOURS
): boolean => {
  if (!isActiveDriverOrder(order)) return false;
  const referenceMs = getDriverOrderTimestamp(order);
  if (!referenceMs) return false;
  return nowMs - referenceMs > staleHours * 60 * 60 * 1000;
};

export const getVisibleDriverOrders = (
  orders: Order[],
  nowMs: number = Date.now(),
  staleHours: number = DEFAULT_STALE_HOURS
): Order[] => orders.filter((order) => isActiveDriverOrder(order) && !isStaleDriverOrder(order, nowMs, staleHours));

export const getStaleDriverOrders = (
  orders: Order[],
  nowMs: number = Date.now(),
  staleHours: number = DEFAULT_STALE_HOURS
): Order[] => orders.filter((order) => isStaleDriverOrder(order, nowMs, staleHours));
